module.exports = __webpack_public_path__ + "static/img/man-3230661.6936886.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/man-3230661.png
// module id = wNBH
// module chunks = 1